import { render } from "./AppTopBar.vue?vue&type=template&id=5204e228&scoped=true"
import script from "./AppTopBar.vue?vue&type=script&lang=js"
export * from "./AppTopBar.vue?vue&type=script&lang=js"

import "./AppTopBar.vue?vue&type=style&index=0&id=5204e228&lang=scss&scoped=true"

import exportComponent from "/home/ben/Projects/harborwall-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5204e228"]])

export default __exports__